import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { When } from 'react-if';
import { testForErrorMap } from 'shared';

import { useGetSelectedOrganisation } from '../../hooks/useGetSelectedOrganisation';
import { Notification } from '../../../common/Atoms/Notification';
import { useInvoice } from '../../hooks/useInvoice';
import { useActionTableModels } from '../../hooks/useActions';
import { SmallSpinner } from '../../../common/Atoms/SmallSpinner';
import { ActionsTable } from '../Actions/ActionsTable';

import { InvoiceHeaderV2 } from './InvoiceV2/InvoiceHeaderV2';

export function InvoicePage() {
  const organisation = useGetSelectedOrganisation();
  const { invoice, isLoading } = useInvoice();

  if (isLoading) {
    return (
      <div className={ `flex justify-center items-center h-96` }>
        <SmallSpinner
          size={ `lg` }
          colored
        />
      </div>
    );
  }

  if (!invoice || !organisation) return null;

  // Starts right under the top nav (cancelling the page's 1.5rem top padding) and fills the viewport
  // down to the page's 1.5rem bottom padding on wide screens: 4rem nav + 1.5rem = 5.5rem
  return (
    <div className={ `-mt-6 flex flex-col gap-5 xl:h-[calc(100dvh-5.5rem)]` }>
      <InvoiceHeaderV2 />
      <When condition={ invoice?.note && invoice.error }>
        <Notification
          type={ `error` }
          title={ `Error` }
        >
          { /* Move to backend transformer after invoiceAPI */ }
          { testForErrorMap(invoice.note) }
        </Notification>
      </When>
      <div className={ `xl:min-h-0 xl:flex-1 xl:overflow-auto` }>
        <Outlet />
      </div>
    </div>
  );
}

export function InvoiceActionsTab() {
  const { resetModels } = useActionTableModels();

  // Filters carried over from the main actions table would hide this invoice's actions
  useEffect(() => {
    resetModels();
  }, []);

  return <ActionsTable />;
}
